
import { Container } from "@mui/material";
import CompareTable from "../components/compare-table";
import CustomMetas from "../components/custom-metas";

const ComparePage = () => {


    return (
        <Container maxWidth="xl" sx={{ mt: "24px", mb: "40px" }}>
            <CustomMetas title="Compare page"
                description="user Compare list data"
                keywords="items compare, user compare list, products compare"
                page_type="product.item"
                noindex
            />
            <CompareTable />
        </Container >
    );
}

export default ComparePage;